import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { flowRight } from 'lodash';
import withAutoToTop from '@/HOC/withAutoToTop';
import WelcomeHeader from '@/components/WelcomeHeader';
import './index.scss';
import { checkIsOneScreen } from '@/service/util';

class Error extends React.Component {
  componentDidMount() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }

  render() {
    const { intl } = this.props;
    const isOneScreen = checkIsOneScreen()
    return (
      <div className="error-page">
        <div className="error-content">
          <WelcomeHeader name={intl.formatMessage({ id: 'app.error' })} />
          <div className="error-body">
            <FormattedMessage id="app.errorPageContent" />
          </div>
          {isOneScreen ? <div className="footer-bg-new" /> : <div className="footer-img" />}
        </div>
        {!isOneScreen && <div className="footer-bg" />}
      </div>
    );
  }
}

export default flowRight([withAutoToTop, injectIntl])(Error);
